import { getApiData } from "../utils/APIHelper";

const ROOM_ENDPOINTS = {
  ROOM_TYPES: "api/rooms/types",
  ROOM_STYLES: "api/rooms/styles",
  ROOM_PALETTES: "api/rooms/palettes",
  CREATE_ROOM: (projectId) => `api/project/${projectId}/room`,
  UPDATE_ROOMS: (projectId) => `api/project/${projectId}/rooms`,
  DELETE_ROOM: (roomId) => `api/project/room/${roomId}`,
};

export const getRoomTypes = async (
  quickSelection = false,
  projectType = null
) => {
  try {
    let endpoint = `${ROOM_ENDPOINTS.ROOM_TYPES}?quick_selection=${quickSelection}`;

    if (quickSelection && projectType) {
      endpoint += `&project_type=${encodeURIComponent(projectType)}`;
    }

    const response = await getApiData(endpoint, "GET", {});
    return response;
  } catch (error) {
    console.error("Error fetching room types:", error);
    throw error;
  }
};

export const getRoomStyles = async (roomName = null) => {
  try {
    const endpoint = roomName
      ? `${ROOM_ENDPOINTS.ROOM_STYLES}?room_name=${encodeURIComponent(roomName)}`
      : ROOM_ENDPOINTS.ROOM_STYLES;
    const response = await getApiData(endpoint, "GET", {});
    return response;
  } catch (error) {
    console.error("Error fetching room styles:", error);
    throw error;
  }
};

export const getRoomPalettes = async () => {
  try {
    const response = await getApiData(ROOM_ENDPOINTS.ROOM_PALETTES, "GET", {});
    return response;
  } catch (error) {
    console.error("Error fetching room palettes:", error);
    throw error;
  }
};

export const createRoom = async (projectId, roomData) => {
  console.log("projectId", projectId);
  try {
    const endpoint = ROOM_ENDPOINTS.CREATE_ROOM(projectId);
    const response = await getApiData(endpoint, "POST", roomData);
    return response;
  } catch (error) {
    console.error("Error creating room:", error);
    throw error;
  }
};

export const createRoomType = async (roomTypeData) => {
  try {
    const response = await getApiData(
      ROOM_ENDPOINTS.ROOM_TYPES,
      "POST",
      roomTypeData
    );
    return response;
  } catch (error) {
    console.error("Error creating room type:", error);
    throw error;
  }
};

export const updateRoom = async (projectId, roomData) => {
  try {
    const endpoint = ROOM_ENDPOINTS.UPDATE_ROOMS(projectId);
    const response = await getApiData(endpoint, "PUT", roomData);
    return response;
  } catch (error) {
    console.error("Error updating room:", error);
    throw error;
  }
};

export const deleteRoom = async (roomId) => {
  try {
    const endpoint = ROOM_ENDPOINTS.DELETE_ROOM(roomId);
    const response = await getApiData(endpoint, "DELETE", {});
    return response;
  } catch (error) {
    console.error("Error deleting room:", error);
    throw error;
  }
};
